import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import styled, {css, injectGlobal} from 'styled-components';
import { rgba } from 'polished';
import { find } from 'lodash';
import { Link } from 'react-router-dom'
import moment from 'moment'
import Fade from 'react-reveal/Fade';

import { fetchPledges, getPledges } from '../Pledge/redux';
import { fetchPledgesPage, getPledgesPage } from './redux';

import { paleGreen } from '../../styles/colors';
import { hoverState, body, padding } from '../../styles/global';
import { media } from '../../styles/utils';
import MetaTags from '../../components/MetaTags/MetaTags';

class Pledges extends Component{
    

    componentWillMount = () => {
        this.props.fetchPledges()
        this.props.fetchPledgesPage()
    }

    resolveColour = (i) => {
        const colours = [
            '#DB5537',
            '#9A66FE',
            '#B8EEB3'
        ]

        return colours[i]
    }
    
    renderPledgeOptions = () => {
        const { pledges } = this.props;

        if (pledges.data) {
            const options = pledges.data.map((pledge, i) => {
                return (
                    <PledgeOption
                        to={`/pledge/${pledge.slug}`}
                        colour={this.resolveColour(i)}
                    >
                        {pledge.title.toUpperCase()}
                    </PledgeOption>
                )
            })
    
            return (
                <PledgeContainer>
                    {options}
                </PledgeContainer>
            )
        }
    }

    render() {
        const { pledges, pledgesPage } = this.props;
        console.log('pledgesPage',pledgesPage);
        return (
            <Container>

                {pledgesPage.acf && (
                   <MetaTags    
                        title={`Pledge`}   
                        description={pledgesPage.acf.pledge_selection_text}
                    />
                )}

                <Fade
                    up
                    duration={1000}
                    distance={'50px'}
                >
                    {pledgesPage.acf && (
                        <div>
                            <IntroText 
                                dangerouslySetInnerHTML={{__html: pledgesPage.acf.pledge_selection_text}}
                            />
                        
                            {this.renderPledgeOptions()}
                        </div>
                    )}
                </Fade>
    
            </Container>
        )
    }
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #F7F7F7;
    min-height: 100vh;
    ${padding}

    .react-reveal {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
`;

const IntroText = styled.div`
    font-family: TiemposText-Regular;
    font-size: 18px;
    color: #4D4D4D;
    letter-spacing: -0.3px;
    text-align: center;
    line-height: 24px;
    margin-bottom: 64px;
    white-space: pre-line;
    margin-top: -64px;
    
    ${media.tablet`
        margin-bottom: 48px;
    `}
`;

const PledgeContainer = styled.div`
    display: flex;

    ${media.tablet`
        flex-direction: column;
    `}
`;

const PledgeOption = styled(Link)`
    display: flex;
    justify-content: center;
    align-items: center;

    background: white;
    box-shadow: 0 2px 1px 0 rgba(0,0,0,0.02);
    border-radius: 8px;

    width: 182px;
    height: 52px;

    font-family: 'Platform-Regular';
    font-size: 14px;
    color: #4D4D4D;
    letter-spacing: 1.28px;
    text-align: center;
    line-height: 9px;    

    transition: all 0.1s ease;

    &:hover {
        color: white;
        background: ${props => props.colour};
        box-shadow: 0 2px 1px 0 rgba(0,0,0,0);
    }

    &:not(:last-child) {
        margin-right: 28px;

        ${media.tablet`
            margin-right: 0;
            margin-bottom: 18px;
        `}
    }

    ${props => {
        if (props.colour == '#B8EEB3') return css`
            &:hover {
                color: #4D4D4D;
            }
        `
    }}
`;



const mapDispatchToProps = dispatch => ({
    fetchPledges() {
        dispatch(fetchPledges())
    },
    fetchPledgesPage() {
        dispatch(fetchPledgesPage())
    }
})

const mapStateToProps = (state, props) => ({
    pledges: getPledges(state),
    pledgesPage: getPledgesPage(state)
})

export default connect(mapStateToProps, mapDispatchToProps)(Pledges);


// WEBPACK FOOTER //
// ./client/modules/Pledges/Pledges.js